export const heroStats = [
  { value: "월 평균 18h", label: "절약된 업무 시간" },
  { value: "2,100+", label: "수익화 성공 사례" },
  { value: "340+", label: "수익형 AI 챌린지" },
];

export const values = [
  {
    id: "earn",
    icon: "ri-money-dollar-circle-line",
    tag: "N잡 수익화",
    title: "배우면 바로 돈이 돼요",
    desc: "이모티콘 승인, 블로그 자동화, 쇼츠 수익 창출. 이론이 아니라 오늘 당장 통장에 찍히는 결과물을 만들어요.",
    color: "#00D873",
  },
  {
    id: "save",
    icon: "ri-timer-flash-line",
    tag: "칼퇴 자동화",
    title: "퇴근 2시간 앞당기기",
    desc: "반복 보고서, 이메일, 회의록을 AI에게 떠넘기세요. 하루 15분 셋팅으로 매일 2시간을 되찾아와요.",
    color: "#FF8C00",
  },
  {
    id: "connect",
    icon: "ri-group-line",
    tag: "성과 인증",
    title: "수익 인증이 또 다른 수익",
    desc: "파티 챌린지로 팀과 함께 프로젝트를 완성하고 수익을 인증하세요. 커뮤니티가 바이럴을 만들어줘요.",
    color: "#FF6B6B",
  },
];

export const socialProofs = [
  {
    id: 1,
    name: "김민준",
    role: "직장인 → N잡러 · 26세",
    avatar: "https://public.readdy.ai/ai/img_res/9af1241fffd4c36a6698f7d5cead0c8e.jpg",
    quote: "이 프롬프트 하나로 자동화 블로그 세팅하고 첫 달에 수익금 32만 원 찍었어요. GrowSeo 아니었으면 시작도 못했을 것 같아요.",
    streak: 42,
    badge: "💸",
  },
  {
    id: 2,
    name: "박지수",
    role: "마케터 · 29세",
    avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20student%20smiling%20casual%20portrait%20bright%20clean%20background%20minimal%20photography&width=80&height=80&seq=sp2&orientation=squarish",
    quote: "주간 보고서 자동화 챌린지 하나로 매일 야근하던 삶이 사라졌어요. 이제 6시에 칼퇴하고 N잡 공부합니다.",
    streak: 28,
    badge: "⏰",
  },
  {
    id: 3,
    name: "이도현",
    role: "직장인 부업러 · 31세",
    avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20freelancer%20smiling%20casual%20portrait%20bright%20clean%20background%20minimal%20photography&width=80&height=80&seq=sp3&orientation=squarish",
    quote: "미드저니 이모티콘 챌린지로 카카오 이모티콘 4세트 승인받고 매달 18만 원이 연금처럼 들어와요. 진짜예요.",
    streak: 65,
    badge: "🎯",
  },
];

export const galleryItems = [
  {
    id: 1,
    user: "최수아",
    challenge: "이모티콘 승인 완료 🎉",
    image: "https://readdy.ai/api/search-image?query=colorful%20cute%20kawaii%20sticker%20emoticon%20character%20design%20AI%20generated%20pastel%20tones%20minimal%20flat%20art%20white%20background%20product&width=300&height=400&seq=g1&orientation=portrait",
    day: 12,
  },
  {
    id: 2,
    user: "정우진",
    challenge: "월 32만원 블로그 수익 인증",
    image: "https://readdy.ai/api/search-image?query=laptop%20screen%20showing%20blog%20analytics%20dashboard%20income%20revenue%20chart%20green%20growth%20numbers%20minimal%20modern%20workspace%20clean&width=300&height=360&seq=g2&orientation=portrait",
    day: 7,
  },
  {
    id: 3,
    user: "한예린",
    challenge: "쇼츠 수익화 조건 달성!",
    image: "https://readdy.ai/api/search-image?query=young%20woman%20celebrating%20phone%20screen%20showing%20youtube%20shorts%20monetization%20milestone%20success%20home%20studio%20warm%20minimal%20lighting&width=300&height=420&seq=g3&orientation=portrait",
    day: 21,
  },
  {
    id: 4,
    user: "오민석",
    challenge: "오늘도 칼퇴 성공 ✅",
    image: "https://readdy.ai/api/search-image?query=person%20leaving%20office%20early%20sunset%20happy%20expression%20business%20casual%20modern%20minimal%20clean%20background%20success%20achievement&width=300&height=380&seq=g4&orientation=portrait",
    day: 5,
  },
];
